import PublicAdminPanelInstance from "../api/PublicAdminPanelInstance";
import { API_ROUTES } from "../api/ApiRoutes";

export const IP_WHITELIST_BLOCKED_STATUS = 404;
export const IP_WHITELIST_BLOCKED_ERROR_CODE = "INVALID_IP";

export const isIpWhitelistBlockedError = (error) =>
  error?.response?.status === IP_WHITELIST_BLOCKED_STATUS &&
  error?.response?.data?.error_code === IP_WHITELIST_BLOCKED_ERROR_CODE;

export const isIpWhitelistAllowedResponse = (response) =>
  response?.status === 200 &&
  response?.data?.success === true &&
  response?.data?.data?.whitelisted === true;

export const parseIpWhitelistStatusResponse = (response) => {
  const defaultLanguage = response?.data?.data?.default_language;
  return {
    allowed: isIpWhitelistAllowedResponse(response),
    defaultLanguage:
      typeof defaultLanguage === "string" ? defaultLanguage : null,
  };
};

export const fetchIpWhitelistStatus = async () => {
  const response = await PublicAdminPanelInstance.get(
    API_ROUTES.IP_WHITELIST_STATUS,
  );
  return parseIpWhitelistStatusResponse(response);
};
